import { render, staticRenderFns } from "./life-force.vue?vue&type=template&id=16e51ab4&"
import script from "./life-force.vue?vue&type=script&lang=js&"
export * from "./life-force.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports